import { A11yModule } from '@angular/cdk/a11y';
import { NgClass } from '@angular/common';
import { ChangeDetectionStrategy, Component, input, output } from '@angular/core';
import { UiButtonComponent } from '@big-direkt/ui/button';
import { IconBigMediumSchliessen, IconComponent } from '@big-direkt/utils/icons';

@Component({
    selector: 'big-ui-modal-frame',
    changeDetection: ChangeDetectionStrategy.OnPush,
    templateUrl: './modal-frame.component.html',
    imports: [A11yModule, UiButtonComponent, IconComponent, NgClass],
    host: {
        class: 'block h-full',
    },
})
export class ModalFrameComponent {
    public readonly iconClose = IconBigMediumSchliessen;
    public readonly closeBtnTitle = input.required<string>();
    public readonly closeModal = output();
    public readonly contentClass = input<string>('');
    public readonly slimHeader = input<boolean>(false);
}
